/*
Image hero: the content box reuses the SAME photo as its own cover
background. The inline style points at the full-size URL (no-JS fallback);
here we swap it to the <img>'s currentSrc so the box always reuses the exact
srcset candidate the browser already downloaded — guaranteed single fetch.
*/

document.querySelectorAll("#hero_image").forEach((hero) => {
  const img = hero.querySelector(".hero__bg img");
  const box = hero.querySelector(".hero__box");
  if (!img || !box) return;

  const sync = () => {
    if (img.currentSrc) {
      box.style.backgroundImage = `url("${img.currentSrc}")`;
    }
  };

  if (img.complete) sync();
  else img.addEventListener("load", sync, { once: true });
});
